import React, { useEffect, useState } from 'react';
import { t } from '@lingui/macro';

import { Minus, Plus } from '@rover/icons';
import { Button, Flex } from '@rover/kibble/core';

type Props = {
  map: google.maps.Map;
};

export default function ZoomControls({ map }: Props): JSX.Element | null {
  const [zoom, setZoom] = useState<number | null>(null);

  useEffect(() => {
    if (!map) return;

    // Set initial zoom
    setZoom(map.getZoom() || 0);

    const listener = map.addListener('zoom_changed', () => {
      setZoom(map.getZoom() || 0);
    });

    // eslint-disable-next-line consistent-return
    return () => listener.remove();
  }, [map]);

  if (!map) {
    return null;
  }

  const zoomIn = (): void => {
    map.setZoom((map.getZoom() || 0) + 1);
  };

  const zoomOut = (): void => {
    map.setZoom((map.getZoom() || 0) - 1);
  };

  return (
    <Flex flexDirection="column">
      <Button
        size="small"
        icon={Plus}
        onClick={zoomIn}
        circular
        aria-label={t`Zoom in`}
        mb="3x"
        // @ts-expect-error
        disabled={!!zoom && zoom >= map.maxZoom}
      />
      <Button
        size="small"
        icon={Minus}
        onClick={zoomOut}
        circular
        aria-label={t`Zoom out`}
        // @ts-expect-error
        disabled={!!zoom && zoom <= map.minZoom}
      />
    </Flex>
  );
}
